export default "__VITE_ASSET__789faca0__"